import React, { useState, useEffect, useRef, memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import logoutUserAutomatically from '../../utils/logoutUserAutomatically';

import api from '../../services/api';

import Header from '../../components/Header';
import PlaylistOfTheMonth from './components/PlaylistOfTheMonth';
import Input from '../../components/Input';
import Footer from '../../components/Footer';
import ResultsFound from './components/ResultsFound';
import LatestLessons from './components/LatestLessons';
import SeriesChannelPri from './components/SeriesChannelPri';
import LessonsChannelPri from './components/LessonsChannelPri';
import ExclusiveSeries from './components/ExclusiveSeries';
import ExclusiveLessons from './components/ExclusiveLessons';
import ExclusivePodcasts from './components/ExclusivePodcasts';
import Filters from './components/Filters';
import WarningCookie from '../../components/WarningCookie';

import searchIcon from '../../assets/icons/search2.png';
import filter from '../../assets/icons/filter.png';

import {
  Container,
  SearchContainer,
  ContainerInput,
  ButtonShowFilters,
  Menu,
  MenuItem,
} from './styles';

const Home = () => {
  const searchRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [searchedLessons, setSearchedLessons] = useState([]);
  const [searchedSeries, setSearchedSeries] = useState([]);
  const [searchedPodcastSeries, setSearchedPodcastSeries] = useState([]);
  const [searchedMeditationSeries, setSearchedMeditationSeries] = useState([]);
  const [searchedPodcasts, setSearchedPodcasts] = useState([]);
  const [searchedMeditations, setSearchedMeditations] = useState([]);
  const [allPodcastsAndMeditationsSeries, setAllPodcastsAndMeditationsSeries] =
    useState([]);
  const [appointments, setAppointments] = useState({});
  const [informationPlaylistOfTheMonth, setInformationPlaylistOfTheMonth] =
    useState({
      data: [],
    });
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState([]);
  const [loadSearch, setLoadSearch] = useState(false);
  const [chosenMenu, setChosenMenu] = useState('');

  const [latestLessons, setLatestLessons] = useState([]);

  const [exclusiveSeries, setExclusiveSeries] = useState([]);
  const [exclusiveSeriesFromChannel, setExclusiveSeriesFromChannel] = useState(
    [],
  );
  const [showSpinnerExclusiveSeries, setShowSpinnerExclusiveSeries] = useState(
    [],
  );
  const [
    showSpinnerExclusiveSeriesFromChannel,
    setShowSpinnerExclusiveSeriesFromChannel,
  ] = useState([]);

  const [exclusiveLessons, setExclusiveLessons] = useState([]);
  const [allKits, setAllKits] = useState([]);

  const [showSpinnerExclusiveLessons, setShowSpinnerExclusiveLessons] =
    useState([]);

  const [exclusiveLessonsFromChannel, setExclusiveLessonsFromChannel] =
    useState([]);
  const [
    showSpinnerExclusiveLessonsFromChannel,
    setShowSpinnerExclusiveLessonsFromChannel,
  ] = useState([]);

  const fetchFilters = async () => {
    await api.get('filter-categories?embed%5B%5D=filters').then((response) => {
      setFilters(response.data);
    });
  };

  useEffect(() => {
    handleSearch();
  }, [selectedFilters]);

  useEffect(() => {
    loadExclusiveSeries();
    loadExclusiveSeriesFromChannel();
    loadLessons();
    loadPodcastKits();
    loadPodcastAndMeditations();
    loadInformationPlaylistOfTheMonth();
    loadAppointments();
    fetchFilters();
    window.scrollTo(0, 0);
    if (logoutUserAutomatically()) {
      dispatch({ type: 'yoga-adm/user/logout' });
      history.push('/login');
    }
  }, []);

  const handleSearch = async () => {
    const value = document.getElementById('search-home').value;
    setSearch(value);

    let filterIds = '';
    for (let i = 0; i < selectedFilters.length; i++) {
      const element = selectedFilters[i].id;
      if (i === 0) {
        filterIds += `filters%5B%5D=${element}`;
      } else {
        filterIds += `&filters%5B%5D=${element}`;
      }
    }

    if (value === '' && selectedFilters.length === 0) {
      setSearchedLessons([]);
      setSearchedSeries([]);
      setSearchedPodcastSeries([]);
      setSearchedMeditationSeries([]);
      setSearchedPodcasts([]);
      setSearchedMeditations([]);
      return;
    }

    let route = '';

    if (value.trim() !== '') {
      route = `search=${value}`;
    }

    if (filterIds.length > 0) {
      if (value.trim() !== '') {
        route += `&`;
      }

      route += filterIds;
    }

    setLoadSearch(true);
    await api
      .get(`/posts/search?${route}`)
      .then((response) => {
        saveSearchResponse(response.data);
        setLoadSearch(false);
      })
      .catch((error) => setLoadSearch(false));
  };

  const saveSearchResponse = (data) => {
    setSearchedSeries(data.series);
    setSearchedLessons(data.lessons);
    setSearchedPodcastSeries(data.podcast_series);
    setSearchedMeditationSeries(data.meditation_series);
    setSearchedPodcasts(data.podcasts);
    setSearchedMeditations(data.meditations);
  };

  const handleMenu = (option) => {
    if (option === chosenMenu) {
      setChosenMenu('');
    } else {
      setChosenMenu(option);
    }
  };

  const handleLatestLessons = (lessons) => {
    setLatestLessons(lessons);
  };

  const renderPlaylistOfTheMonth = () => {
    if (
      JSON.stringify(appointments) !== '{}' &&
      JSON.stringify(informationPlaylistOfTheMonth) !== '{}' &&
      informationPlaylistOfTheMonth.playlist
    ) {
      return (
        <PlaylistOfTheMonth
          data={informationPlaylistOfTheMonth}
          calendarAppointments={informationPlaylistOfTheMonth.data}
          showAllAppointments={false}
        />
      );
    }
  };

  const loadPodcastAndMeditations = async () => {
    try {
      const response = await api.get('/podcast-series/published');

      setAllPodcastsAndMeditationsSeries(response.data);

      
    } catch (error) {}
  };

  const loadPodcastKits = async () => {
    try {
      const response = await api.get('/podcast-series');

      setAllKits(response.data);

      console.log(response.data)
    } catch (error) {}
  };

  const loadInformationPlaylistOfTheMonth = async () => {
    await api.get('/appointments/official?playlist=true').then((response) => {
      setInformationPlaylistOfTheMonth(response.data);
    });
  };

  const loadAppointments = async () => {
    await api.get('/student-appointments').then((response) => {
      setAppointments(response.data);
    });
  };

  const loadExclusiveSeries = async () => {
    setShowSpinnerExclusiveSeries(true);

    await api
      .get('/series/published?is_exclusive=true')
      .then((response) => {
        setExclusiveSeries(response.data);
        setShowSpinnerExclusiveSeries(false);
      })
      .catch((error) => setShowSpinnerExclusiveSeries(false));
  };

  const loadExclusiveSeriesFromChannel = async () => {
    setShowSpinnerExclusiveSeriesFromChannel(true);

    await api
      .get('/series/published?is_from_the_channel=true')
      .then((response) => {
        setExclusiveSeriesFromChannel(response.data);
        setShowSpinnerExclusiveSeriesFromChannel(false);
      })
      .catch((error) => setShowSpinnerExclusiveSeriesFromChannel(false));
  };

  const loadLessons = async () => {
    setShowSpinnerExclusiveLessons(true);

    await api
      .get(`lessons/published`)
      .then(({ data }) => {
        const exclusiveLessons = data.filter(
          (item) => item.is_exclusive === true,
        );

        const nonExclusiveLessons = data.filter(
          (item) => item.is_exclusive !== true,
        );

        nonExclusiveLessons.reverse();

        setExclusiveLessons(exclusiveLessons);
        setExclusiveLessonsFromChannel(nonExclusiveLessons);
          console.log(data)
        handleLatestLessons(data);
        setShowSpinnerExclusiveLessons(false);
        setShowSpinnerExclusiveLessonsFromChannel(false);
      })
      .catch((error) => {
        setShowSpinnerExclusiveLessons(false);
        setShowSpinnerExclusiveLessonsFromChannel(false);
      });
  };

  const renderFilters = () => {
    if (showFilters) {
      return (
        <Filters
          filters={filters}
          setFilters={setFilters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          handleSearch={handleSearch}
        />
      );
    }
  };

  // const renderMenu = () => {
  //   if (search.trim() === '' && selectedFilters.length === 0) {
  //     return (
  //       <Menu>
  //         <MenuItem
  //           code="Vídeos e Séries"
  //           chosenMenu={chosenMenu}
  //           onClick={() => handleMenu('Vídeos e Séries')}
  //         >
  //           <span>Vídeos e Séries</span>
  //           <div></div>
  //         </MenuItem>

  //         <MenuItem
  //           code="Podcasts"
  //           chosenMenu={chosenMenu}
  //           onClick={() => handleMenu('Podcasts')}
  //         >
  //           <span>Podcasts</span>
  //           <div></div>
  //         </MenuItem>
  //       </Menu>
  //     );
  //   }
  // };

  function renderContent() {
    if (search.trim() === '' && selectedFilters.length === 0) {
      return (
        <>
          {(chosenMenu === '' || chosenMenu === 'Vídeos e Séries') && (
            <LatestLessons
              latestLessons={latestLessons}
              showSpinner={showSpinnerExclusiveLessons}
            />
          )}

          {/* {(chosenMenu === '' || chosenMenu === 'Vídeos e Séries') && (
            <ExclusiveSeries
              exclusiveSeries={exclusiveSeries}
              showSpinner={showSpinnerExclusiveSeries}
            />
          )} */}

          {(chosenMenu === '' || chosenMenu === 'Vídeos e Séries') && (
            <ExclusiveLessons
              exclusiveLessons={allPodcastsAndMeditationsSeries}
              showSpinner={showSpinnerExclusiveLessons}
            />
          )}

          {/* {(chosenMenu === '' || chosenMenu === 'Vídeos e Séries') && (
            <LessonsChannelPri
              exclusiveLessonsFromChannel={exclusiveLessonsFromChannel}
              showSpinner={showSpinnerExclusiveLessonsFromChannel}
            />
          )} */}
          {/* 
          {(chosenMenu === '' || chosenMenu === 'Vídeos e Séries') && (
            <SeriesChannelPri
              allSeries={exclusiveSeriesFromChannel}
              showSpinner={showSpinnerExclusiveSeriesFromChannel}
            />
          )} */}

          {(chosenMenu === '' || chosenMenu === 'Podcasts') && (
            <ExclusivePodcasts
              allPodcastsAndMeditations={allKits}
            />
          )}
        </>
      );
    } else {
      return (
        <ResultsFound
          loadSearch={loadSearch}
          searchedLessons={searchedLessons}
          searchedSeries={searchedSeries}
          searchedPodcastSeries={searchedPodcastSeries}
          searchedMeditationSeries={searchedMeditationSeries}
          searchedPodcasts={searchedPodcasts}
          searchedMeditations={searchedMeditations}
        />
      );
    }
  }

  return (
    <Container>
      <Header />
      {/* {renderPlaylistOfTheMonth()} */}
      <SearchContainer className="search-container">
        <ContainerInput className="hero">
          <Input
            id="search-home"
            inputRef={searchRef}
            placeholder="Buscar"
            iconRight={searchIcon}
            onClickIconRight={() => handleSearch()}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <ButtonShowFilters
            className="filters__button"
            onClick={() => setShowFilters(!showFilters)}
          >
            <img src={filter} alt="Ícone de filtros" />
            Filtrar busca
          </ButtonShowFilters>
        </ContainerInput>
        {renderFilters()}
      </SearchContainer>
      {/* <Content>{renderMenu()}</Content> */}
      {renderContent()}
      <Footer />
      <WarningCookie />
    </Container>
  );
};

export default memo(Home);
